import store from '@/store/index'
import { getEnvObj } from '@/utils/env'
import { uuid } from '@/utils'

const envObj = getEnvObj()

let verify
const _downloadJS = function _downloadJS(src) {
  if (window.sfCaptchaElement) return
  window.sfCaptchaElement = document.createElement('script')
  window.sfCaptchaElement.src = src
  document.body.appendChild(window.sfCaptchaElement)
}

export const SfCaptchaInit = () => {
  _downloadJS(envObj.SF_CAPTCHA_URL)
}

// const _SfCaptchaValid = function _SfCaptchaValid({ containerId, bId, language }, callback) {
// if (!callback) {
//   console.error('需要第一个参数定义callbacks {successCallback: function, failCallback: function}')
//   return
// }

// try {
// console.log('containerId', containerId, bId)
// } catch (error) {
//   _loadErrorCallback(callback)
// }
// }

// var _loadErrorCallback = function _loadErrorCallback(callback) {
//   var CaptchaAppId = ''
//   var ticket = 'sf_terror_1001_' + CaptchaAppId + Math.floor(new Date().getTime() / 1000)
//   callback({
//     ret: 0,
//     randstr: '@' + Math.random().toString(36).substr(2),
//     ticket: ticket,
//     errorCode: 1001,
//     errorMessage: 'jsload_error_sf'
//   })
// }
// const appIdObj = {
//   'SIT': 'icas_sit',
//   'UAT': 'icas_uat',
//   'PRD': 'icas_prd'
// }
// const baseUrlObj = {
//   'SIT': 'https://cas-captcha.sit.sf-express.com/captcha-api',
//   'UAT': 'https://cas-captcha.sit.sf-express.com:9887/captcha-api',
//   'PRD': 'https://cas-captcha.sf-express.com/captcha-api'
// }
export const SfCaptchaValid = (callback) => {
  const language = store.getters.language
  const lang = {
    'zh-CN': 'chs',
    'zh-HK': 'cht',
    'en': 'en',
    'ja-JP': 'en',
    'ko-KR': 'en',
    'th-TH': 'en',
    'vi-VN': 'en'
  }
  const body = document.body
  var allBox = document.querySelectorAll('.sf-captcha')
  if (allBox.length > 0) {
    for (var i = 0; i < allBox.length; i++) {
      body.removeChild(allBox[i])
    }
  }

  const domainObj = {
    'icas_sit_CN': 'ibu-icas.sit.sf-express.com',
    'icas_sit_SG': 'ibu-icas-sit.sf.global',
    'icas_uat_CN': 'ibu-icas-uat.sit.sf-express.com',
    'icas_uat_SG': 'icas-uat.sf.global',
    'icas_prd_CN': 'ibu-icas.sf-express.com',
    'icas_prd_SG': 'icas.sf.global',
  }

  // 添加 div
  const div = document.createElement('div')
  const id = uuid()
  div.setAttribute('id', id)
  div.setAttribute('class', 'sf-captcha')
  body.appendChild(div)
  const str = `${envObj.SF_CAPTCHA_APP_ID}_${envObj.CURRENT_SITE}`
  console.log('domainKey-- ', str)
  verify = new window.SfCaptcha(id, {
    baseUrl: envObj.SF_CAPTCHA_BASE_URL,
    mode: 'pop',
    appId: envObj.SF_CAPTCHA_APP_ID,
    domain: domainObj[str],
    language: lang[language],
    containerId: 'btn',
    success: function(params) {
      // 验证成功后从params获取到token传回给后端校验
      setTimeout(() => {
        callback(params)
      }, 800)
      console.log('params:', params)
    },
    // error: 验证失败的回调
    error: function(error) {
      console.error('error:', error)
    }
  })
  verify.showPop()
}
export const removeSfCaptcha = () => {
  verify && verify.remove()
}

